export default __webpack_public_path__ + "static/media/superDoc.43a7b405.png";